Ext.define('Ext.ux.form.field.ComboBoxExdSimple', {
    extend: 'Ext.ux.form.field.ComboBoxExd',
    alias: 'widget.comboexdsimple',
    displayField: 'text',
    valueField: 'value',
    forceSelection: true,
    allowBlank: false,
    defaultValue: null,
    initComponent: function () {
        this.store = {
            type: 'store',
            model: Ext.define(this.id + 'model_comboexdsimple', {
                extend: 'Ext.data.Model',
                idProperty: "value",
                fields: ['text', 'value']
            }),
            proxy: {
                type: 'memory',
                reader: {
                    type: "json"
                }
            }
        };
        this.callParent(arguments);
        if (this.value === null) {
            this.setValue2Default(this.defaultValue);
        }
    }
});
